<template>
    <div>
        <div v-if="!dialogVisible">
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">打卡照片查询</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

                    <el-row>

                        <!-- 左侧组织架构 --> 
                        <el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
                            <Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
                        </el-col>

                        <!-- 右侧列表 -->
                        <el-col :span="20">

                            <el-row style="padding-left: 46px; padding-top: 40px;">

                                <el-col :span="9">
                                    <span>时间</span>
                                    <el-date-picker v-model="condition.photos_date" type="date" placeholder="请选择" value-format="yyyy-MM-dd"
                                        style="margin-left: 10px;">
                                    </el-date-picker>
                                </el-col>

                                <el-col :span="4">
                                    <el-button
                                        style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                        @click="Find">
                                        查询</el-button>
                                </el-col>
                            </el-row>

                            <el-row style="margin: 0px 10%; margin-top: 50px;height:540px; overflow-x:hidden">
                                <el-row  v-for="(item,index) in tableData" :key="index">
                                    <img :src="item.photos">
                                </el-row>
                                <!-- <el-row style="margin-top: 10px; text-align: center;">
                                    <el-pagination background @current-change="handleCurrentChange"
                                        :page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
                                    </el-pagination>
                                </el-row> -->
                            </el-row>

                        </el-col>
                    </el-row>

                </div>
            </el-row>
        </div>

    </div>
</template>

<script>
    import Structure from "../../utils/structure/structure.vue";

    import axios from "axios";
    export default {
        components: {
            Structure: Structure,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //页面相关
                dialogVisible: false,

                //条件
                condition: {
                    project_id: "",
                    photos_date:this.$globals.getNowTime(),
                },

                //详情
                form: {
                    id: '',
                    photos:'',
                },

                //复选框ids
                ids: [],
            };
        },
        methods: {
            Return() {
                this.dialogVisible = false;
                this.Find();
            },
            //查询
			async Find() {
				var url = '/ClockInPhotos/select';
				var record = {
					page_num: this.page_num,
                    page_size: this.page_size,
                    photos_date: this.condition.photos_date,
                    organize_id: this.condition.project_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data;
                        this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
                }
			},
            //分页
            handleCurrentChange(val) {
                this.page_num = val
                this.Find();
            },

        },
        async created() {
            this.Find();
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
    >>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// dkzp.vue?5277572e